<script>
import ButtonGroup from '../button-group/index.vue'
import Button from '../button/index.vue'
import scrollbarPrettify from '../../../directives/scrollbar-prettify/index'

const BUTTON_GROUP_TYPE = ['primaryGroup', 'plainGroup']

export default {
  name: 'sy-button-gallery',
  components: {Button, ButtonGroup},
  props: {
    // 批量按钮排列位置 | String 可选值：horizontal, vertical 默认值： horizontal
    position: {type: String, default: 'horizontal'},
    // 数量控制超出隐藏 | Number | -  
    maxLength: {type: Number},
    // 按钮循环列表     | Array  | []
    buttonList: {type: Array, default: () => []}
    // buttonList[].size| 按钮尺寸 | String | defalut（默认按钮40px）/ middle（中型按钮32px） / mini（小按钮28px）
  },
  watch: {
    buttonList: {
      deep: true,
      immediate: true,
      handler (buttonList) {
        this._calcListStatus(buttonList.filter(v => !v.hidden))
      }
    }
  },
  directives: {
    scrollbarPrettify
  },
  data () {
    return {
      // 显示按钮
      visibleBtnList: [],
      // 隐藏按钮
      hideBtnList: [],
      hideIconSize: ''
    }
  },
  render (h) {
    return (
      <div
        class={{
          'sy-button-gallery-wrap': true,
          'sy-button-gallery__horizontal-wrap': this.position === 'horizontal',
          'sy-button-gallery__vertical-wrap': this.position === 'vertical'
        }}
      >
        {
          this.visibleBtnList.map((v, idx) => {
            if (v.render) {
              return v.render()
            } else if (this.position === 'vertical') {
              return <div
                key={idx}
                class="sy-button-gallery__vertical-item font-color-link"
              >
                <Button
                  key={idx}
                  {...{
                    props: {
                      ...v,
                      type: 'link'
                    },
                    attrs: v.bind
                  }}
                  on={{...(v.event && v.event)}}
                >{v.name}</Button>
              </div>
            } else {
              // 按钮组
              if (BUTTON_GROUP_TYPE.includes(v.type)) {
                return <ButtonGroup
                  class="button-gallery-item"
                  key={idx}
                  button={v}
                ></ButtonGroup>
              } else {
                return <Button
                  class="button-gallery-item"
                  key={idx}
                  {...{props: v, attrs: v.bind}}
                  on={{...(v.event && v.event)}}
                >{v.name}</Button>
              }
            }
          })
        }
        <el-popover
          vShow={this.maxLength && this.hideBtnList.length}
          placement="bottom-end"
          class="icon-more-popover"
          title=""
          trigger="hover"
          popper-class="sy-button-gallery-show-all-popper"
        >
          <div
            slot="reference"
            class={[
              this.position === 'vertical' ? 'sy-button-gallery-show-all-icon-vertical font-color-link' : 'sy-button-gallery-show-all-icon font-color-primary',
              this.hideIconSize ? 'sy-button-gallery-show-all-icon--' + this.hideIconSize : ''
            ]}
          ><i class="el-icon-more"></i></div>
          <div class="sy-button-gallery-more-wrap" v-scrollbarPrettify>
            {
              this.hideBtnList.map((item, idx) => {
                return <div
                  class={[
                    {
                      'sy-button-gallery-more-item': true,
                      'sy-button-gallery-more-item__disabled': item.bind && item.bind.disabled
                    },
                    item.size ? 'sy-button-gallery-more-item--' + item.size : ''
                  ]}
                >
                  <Button
                    key={idx}
                    {...{
                      props: {
                        ...item,
                        type: 'text'
                      },
                      attrs: item.bind
                    }}
                    on={{...(item.event && item.event)}}
                  >{item.name}</Button>
                </div>
              })
            }
          </div>
        </el-popover>
      </div>)
  },
  methods: {
    handleButtonClick (item) {
      this.$emit('click', item)
    },
    _calcListStatus (buttonList) {
      let [visible, hide] = [[], []]
      for (let i = 0; i < buttonList.length; i++) {
        const item = buttonList[i]
        if (!this.hideIconSize) this.hideIconSize = item.size
        // 判断是否需要数量控制 并且按钮list长度大于maxLength
        if (!this.maxLength || (this.maxLength && i < this.maxLength)) {
          visible.push(item)
        } else {
          // 隐藏区里面的按钮组需要把数据拉平展示
          if (BUTTON_GROUP_TYPE.includes(item.type)) {
            hide = hide.concat(item.buttonList)
          } else {
            hide.push(item)
          }
        }
      }
      this.visibleBtnList = visible
      this.hideBtnList = hide
      // if (this.maxLength && buttonList.length > this.maxLength) {
      //   this.visibleBtnList = buttonList.slice(0, this.maxLength)
      //   this.hideIconSize = this.visibleBtnList[0].size
      //   let arr = []
      //   for (let i = 0; i < buttonList.slice(this.maxLength).length; i++) {
      //     const v = buttonList.slice(this.maxLength)[i]
      //     if (BUTTON_GROUP_TYPE.includes(v.type)) {
      //       arr = arr.concat(v.buttonList)
      //     } else {
      //       arr.push(v)
      //     }
      //   }
      //   this.hideBtnList = arr
      // } else {
      //   this.visibleBtnList = buttonList
      // }
    }
  }
}
</script>

<style scoped lang="scss">
.sy-button-gallery-wrap {
  .button-gallery-item+.button-gallery-item {
    margin-left: 8px;
  }
  .sy-button-gallery-show-all-icon {
    display: inline-block;
    width: 36px;
    text-align: center;
    border: 1px solid currentColor;
    border-radius: 2px;
    font-size: 12px;
    cursor: pointer;
    margin-left: 8px;
  }
  .sy-button-gallery-show-all-icon-vertical {
    display: inline-block;
    cursor: pointer;
    font-size: 12px;
  }
  .sy-button-gallery-show-all-icon--default {
    height: 38px;
    line-height: 38px;
  }
  .sy-button-gallery-show-all-icon--medium {
    height: 34px;
    line-height: 34px;
  }
  .sy-button-gallery-show-all-icon--small {
    height: 30px;
    line-height: 30px;
  }
  .sy-button-gallery-show-all-icon--mini {
    height: 26px;
    line-height: 26px;
  }
}
.sy-button-gallery__vertical-wrap {
  .sy-button-gallery__vertical-item {
    font-size: 12px;
    i.iconfont {
      font-size: 12px;
    }
  }
}
</style>
<style lang="scss">
.sy-button-gallery-show-all-popper {
  padding: 8px 0;
  min-width: 80px;
  max-width: 320px;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  overflow: hidden;
  .sy-button-gallery-more-item {
    width: 100%;
    line-height: 22px;
    padding: 5px 16px;
    box-sizing: border-box;
    font-size: 14px;
    color: #343434;
    /* hover颜色 */
    &:hover {
      background-color: #F4FAFF;
      // 鼠标滑入按钮组件才变成小手，方便用户确认按钮具体点击范围
      // cursor: pointer;
    }
    .iconfont {
      font-size: 14px;
    }
    // 解决按钮画廊下拉里面 只能点击文本才触发事件的问题
    .sy-button {
      width: 100%;
    }
  }
  .sy-button-gallery-more-item__disabled {
    color: #E8EAF2;
    &:hover {
      cursor: not-allowed;
    }
  }
  .sy-button-gallery-more-item--default, .sy-button-gallery-more-item--middle {
    font-size: 14px;
    .iconfont {
      font-size: 14px;
    }
  }
  .sy-button-gallery-more-item--mini {
    font-size: 12px;
    .iconfont {
      font-size: 12px;
    }
  }
}
.sy-button-gallery-button-tooltip-wrap {
  max-width: 220px;
}
.sy-button-gallery-more-wrap {
  max-height: 380px;
  overflow-y: auto;
}
</style>